import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subject, Subscription, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GenericTimerService {

  private elapsedTimeMap: Map<string, number> = new Map();
  private startValueMap: Map<string, number> = new Map();

  public countdownSubject$ : Map<string, BehaviorSubject<number>> = new Map();

  private subscription: Map<string, Subscription> = new Map();

  constructor() { 
  }


 startCountdown(counterId:string,startValue:number = 120) {
  // Aynı sayaç için önceki interval açık kaldıysa kapat; yoksa sayaç katlanarak hızlanır
  this.subscription.get(counterId)?.unsubscribe();
  this.elapsedTimeMap.set(counterId, 0);
  this.startValueMap.set(counterId, startValue);
  if (!this.countdownSubject$.has(counterId)) {
    this.countdownSubject$.set(counterId, new BehaviorSubject<number>(this.startValueMap.get(counterId)));
  }
  this.subscription.set(counterId, interval(1000).subscribe(() => {
      this.elapsedTimeMap.set(counterId, this.elapsedTimeMap.get(counterId) + 1);
      const remaining = this.startValueMap.get(counterId) - this.elapsedTimeMap.get(counterId);
      
      this.countdownSubject$.get(counterId)?.next(remaining);
      if (this.countdownSubject$.get(counterId).value == 0) {
        this.elapsedTimeMap.set(counterId, 0);
      }
    }));
}

stopCountdown(counterId: string) {
  // Aboneliği temizle
  if (this.subscription.has(counterId)) {
    this.subscription.get(counterId)?.unsubscribe();
    this.subscription.delete(counterId); // Aboneliği map'ten kaldır
  }

  // BehaviorSubject'i tamamlayıp temizle
  if (this.countdownSubject$.has(counterId)) {
    this.countdownSubject$.get(counterId)?.complete();
    this.countdownSubject$.delete(counterId);
  }

  // Sayaç ve başlangıç değerlerini kaldır
  this.elapsedTimeMap.delete(counterId);
  this.startValueMap.delete(counterId);
}
}
